import { styled } from '@mui/material/styles';

export const StyledVirtualListContainerDiv = styled('div')<{
  hasError: boolean;
}>`
  border: 1px solid ${({ theme, hasError }) => (hasError ? theme.palette.error.main : theme.palette.divider)};
`;
